export const MIN_PASS_LENGTH = 6;

const CYRILLIC_RE = /[Ѐ-ӿ]/;

export const makePassRules = (t) => [
  (v) => !!v || t('Please enter password'),
  (v) => !CYRILLIC_RE.test(v || '') || t('Password must not contain Cyrillic characters'),
  (v) => /[A-Z]/.test(v) || t('Password must contain at least one uppercase letter'),
  (v) => /[a-z]/.test(v) || t('Password must contain at least one lowercase letter'),
  (v) => /[0-9]/.test(v) || t('Password must contain at least one digit'),
  (v) =>
    (v || '')?.length >= MIN_PASS_LENGTH || t('Password must have at least {min} symbols', { min: MIN_PASS_LENGTH }),
];

export const makeNotEmptyRules = (t) => [(v) => !!v || t('Please enter password')];
